module.exports = __webpack_public_path__ + "media/about.c12ec6a1.mp4";